import { BrowserRouter, Route, Switch } from "react-router-dom";
import AddressData from "../pages/AddressData";
import ContactData from "../pages/ContactPage";
import Home from "../pages/Data";
import PaymentPage from "../pages/PaymentPage";
import { PyamentAproved } from "../pages/PyamentAproved";
import { PyamentFail } from "../pages/PyamentFail";
import { UserCardPage } from "../pages/UserCardPage";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/cartao" component={UserCardPage} />
      <Route path="/falha" component={PyamentFail} />
      <Route path="/sucesso" component={PyamentAproved} />
      <Route path="/endereco" component={AddressData} />
      <Route path="/contato" component={ContactData} />
      <Route path="/pagamento" component={PaymentPage} />
      <Route path="/" component={Home} />
     
    </Switch>
  </BrowserRouter>
);

export default Routes;
